import emailjs from '@emailjs/browser';

// ─── YOUR EMAILJS CREDENTIALS ─────────────────────────────────────────────
const PUBLIC_KEY            = 'VJ61eW-g2tGZRH0J4';
const SERVICE_ID            = 'service_f7bedii';
const CONTACT_TEMPLATE_ID   = 'template_h3y1kkw';
const BOOKING_TEMPLATE_ID   = 'template_h3y1kkw';
const AUTOREPLY_TEMPLATE_ID = 'template_wqegz5r';
const BUSINESS_EMAIL        = 'Yndreamcurtains@gmail.com';
// ──────────────────────────────────────────────────────────────────────────

// Initialize once on load
emailjs.init({ publicKey: PUBLIC_KEY });

/** Send contact form enquiry to business inbox */
export async function sendContactEmail({ name, email, phone, subject, message }) {
  return emailjs.send(SERVICE_ID, CONTACT_TEMPLATE_ID, {
    from_name:  name,
    from_email: email,
    reply_to:   email,
    phone:      phone || 'Not provided',
    subject:    subject || 'General Enquiry',
    message,
    to_email:   BUSINESS_EMAIL,
    sent_at:    new Date().toLocaleString('en-AU', { timeZone: 'Australia/Adelaide' }),
  });
}

/** Send booking request to business + auto-reply to customer */
export async function sendBookingEmail(form) {
  const params = {
    customer_name:  form.name,
    customer_email: form.email,
    customer_phone: form.phone,
    reply_to:       form.email,
    address:        form.address,
    suburb:         form.suburb,
    state:          form.state   || '',
    country:        form.country || 'Australia',
    postcode:       form.postcode|| '',
    rooms:          form.rooms   || 'Not specified',
    date:           form.date,
    time:           form.time,
    products:       form.products.length ? form.products.join(', ') : 'Not specified',
    notes:          form.notes   || 'None',
    to_email:       BUSINESS_EMAIL,
    sent_at:        new Date().toLocaleString('en-AU', { timeZone: 'Australia/Adelaide' }),
  };

  // Email to business
  await emailjs.send(SERVICE_ID, BOOKING_TEMPLATE_ID, params);

  // Auto-reply to customer (To Email in template = {{customer_email}})
  await emailjs.send(SERVICE_ID, AUTOREPLY_TEMPLATE_ID, {
    ...params,
    to_email: form.email,
  });
}
